import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { useSessaoAtual } from 'services/app';
import { TransferenciaPostModel } from 'model/api/gestao/transferencia/transferencia-post-model';
import { ApiListModel } from 'model/api/api-list-model/api-list-model';
import { TransferenciaListModel } from 'model/api/gestao/transferencia/transferencia-list-model';

export function usePostTransferencia() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<TransferenciaListModel>>()

    const { getEmpresa } = useSessaoAtual();

    const postTransferencia = useCallback(
        (model: TransferenciaPostModel) => {
            model.empresaId = getEmpresa().Id;
            return invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/Transferencia`,
                data: model,
                enviarTokenUsuario: true
            })
        },
        [getEmpresa, invocarApi],
    );
    return {
        ...outrasPropriedades,
        postTransferencia,
    };
}
